var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecursoCanarias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.89 3.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0e0e0e;\r\n        stroke: #5c5c5c;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: .2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.19 1.95 2.73 2.29 2.27 1.6 3.46 1.26 3.19 1.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.35 2.18 7.25 1.88 7.04 1.16 6.35 2.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.86,1.43l-.12-.71.12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.28.72l.54-.66-.54.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: ".2 2.73 .86 2.53 .61 3.1 .2 2.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.57 2.15 1.68 1.85 1.98 2 1.9 2.33 1.57 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.5 2.03 4.75 2.11 4.64 2.77 4.05 2.69 4.13 2.18 4.5 2.03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecursoCanarias);
export default __webpack_public_path__ + "static/media/recurso-canarias.37b203a7.svg";
export { ForwardRef as ReactComponent };